// Polyfills for IE11 and other ES5 browsers
// To maintain quality, we prefer polyfills without additives
// For example, we prefer Promise implementation from "core-js" than "bluebird"

// To reduce conflicts with hosting app, we should consider using
// @babel/plugin-transform-runtime to polyfill in transpiled code directly.

import 'core-js/features/array/find-index.js';
import 'core-js/features/array/find.js';
import 'core-js/features/array/from.js';
import 'core-js/features/array/includes.js';
import 'core-js/features/array/iterator.js';
import 'core-js/features/dom-collections/index.js';
import 'core-js/features/map/index.js';
import 'core-js/features/math/sign.js';
import 'core-js/features/number/is-finite.js';
import 'core-js/features/object/assign.js';
import 'core-js/features/object/entries.js';
import 'core-js/features/object/from-entries.js';
import 'core-js/features/object/is.js';
import 'core-js/features/object/values.js';
import 'core-js/features/promise/index.js';
import 'core-js/features/promise/finally.js';
import 'core-js/features/set/index.js';
import 'core-js/features/string/ends-with.js';
import 'core-js/features/string/starts-with.js';
import 'core-js/features/symbol/index.js';
import 'url-search-params-polyfill';
import 'whatwg-fetch';
